/* eslint max-lines: 0 */
/* eslint max-lines-per-function: 0 */
const BaseComponent = require('./Base');
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Card = require('./Card');
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Toggle = require('./Toggle');
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const HorizontalCard = require('./HorizontalCard');
const ClinicDefinitionAPI = require('../services/api/clinicdefinition');
const AccessControlAPI = require('../services/api/accesscontrol');
const isSafari = require('../utils/isSafari');
const lensSVG = require('../../assets/lens.svg');
const dropDownSVG = require('../../assets/dropdown.svg');
const clinicDefinitionService = new ClinicDefinitionAPI();
const accessControlService = new AccessControlAPI();
const setScrollPosition = require('../utils/setScrollPosition');
const { ITEMS_PER_PAGE } = require('../utils/constants');

const {
  FETCH_LDAP_GROUPS,
  FETCH_FACILITIES,
  FETCH_SPECIALITIES,
  FETCH_USER_GROUPS,
  FETCH_CREDENTIALS,
  FETCH_LDAP_GROUP_USERS,
  UPDATE_SELECTED_FACILITY,
  UPDATE_SELECTED_SPECIALTY,
  UPDATE_SELECTED_USER,
  UPDATE_SELECTED_USER_GROUP,
  PAGINATE_CREDENTIALS_USERS,
} = require('../events');

const eventBus = require('../utils/EventBus');

class Credentials extends BaseComponent {
  constructor() {
    super();
    this._useEvents = true;
    this._useScroll = true;
    this.fetching = false;
    this.offset = 0;
  }

  static get observedAttributes() {
    return ['selectedspecialty', 'selectedfacility', 'selectedusergroup', 'selecteduser', 'showenabled', 'userfilter'];
  }

  attachEvents() {
    const facilitySelect = this.shadowRoot.querySelector('.facility-select');
    const specialtySelect = this.shadowRoot.querySelector('.specialty-select');
    const ugroupSelect = this.shadowRoot.querySelector('.ugroup-select');
    const showEnabledToggle = this.shadowRoot.querySelector('.show-enabled');
    const searchInput = this.shadowRoot.querySelector('.user-search');

    facilitySelect.addEventListener('change', () => {
      eventBus.fire(UPDATE_SELECTED_FACILITY, {
        facilityId: facilitySelect.value,
      });
    });

    specialtySelect.addEventListener('change', () => {
      eventBus.fire(UPDATE_SELECTED_SPECIALTY, {
        specialtyId: specialtySelect.value,
      });
    });

    ugroupSelect.addEventListener('change', () => {
      eventBus.fire(UPDATE_SELECTED_USER_GROUP, {
        userGroupId: ugroupSelect.value,
      });
    });

    if (showEnabledToggle) {
      showEnabledToggle.addEventListener('click', () => {
        this.showEnabled = this.showEnabled === 'true' ? 'false' : 'true';
      });
    }

    if (searchInput) {
      if (this.userFilter) {
        searchInput.defaultValue = this.userFilter;
        const filterLength = this.userFilter.length;
        searchInput.setSelectionRange(filterLength, filterLength);
      }

      searchInput.addEventListener('keyup', e => {
        if (e.key === 'Enter') {
          this.userFilter = this.currentFilter;
        } else {
          this.currentFilter = e.currentTarget.value;
        }
      });
      searchInput.focus();
    }
  }

  async connectedCallback() {
    eventBus.registerOnce(UPDATE_SELECTED_FACILITY, async ({ detail }) => {
      this.selectedFacility = detail.facilityId;
      this.selectedSpecialty = null;
      this.selectedUserGroup = null;
      eventBus.fire(FETCH_SPECIALITIES, {
        data: await clinicDefinitionService
          .facilities({
            facilityId: detail.facilityId,
          })
          .specialties()
          .get({
            parameters: {
              is_enabled: true,
            },
          }),
      });
      eventBus.fire(FETCH_LDAP_GROUP_USERS, {
        data: [],
      });
      eventBus.fire(FETCH_CREDENTIALS, {
        data: [],
      });
    });

    eventBus.registerOnce(UPDATE_SELECTED_SPECIALTY, async ({ detail }) => {
      this.selectedSpecialty = detail.specialtyId;
      this.selectedUserGroup = null;
      eventBus.fire(FETCH_USER_GROUPS, {
        data: await clinicDefinitionService
          .facilities({ facilityId: this.selectedFacility })
          .specialties({ specialtyId: detail.specialtyId })
          .userGroups()
          .get(),
      });
      eventBus.fire(FETCH_LDAP_GROUP_USERS, {
        data: [],
      });
      eventBus.fire(FETCH_CREDENTIALS, {
        data: [],
      });
    });

    eventBus.registerOnce(UPDATE_SELECTED_USER_GROUP, async ({ detail }) => {
      this.userFilter = '';
      this.selectedUserGroup = detail.userGroupId;
      eventBus.fire(FETCH_LDAP_GROUP_USERS, {
        data: await accessControlService
          .userGroups({ groupId: detail.userGroupId })
          .users()
          .get({ parameters: { specialtyId: this.selectedSpecialty, limit: ITEMS_PER_PAGE } }),
      });
    });

    eventBus.registerOnce(UPDATE_SELECTED_USER, ({ detail }) => {
      this.selectedUser = detail.userId;
    });

    this.listenForEvents(
      [
        { event: FETCH_FACILITIES, key: 'facilities' },
        { event: FETCH_SPECIALITIES, key: 'specialities' },
        { event: FETCH_USER_GROUPS, key: 'groups' },
        { event: FETCH_LDAP_GROUPS, key: 'ldap' },
        { event: FETCH_LDAP_GROUP_USERS, key: 'users' },
        { event: FETCH_CREDENTIALS, key: 'credentials' },
      ],
      eventBus,
    );

    eventBus.fire(FETCH_FACILITIES, {
      data: await clinicDefinitionService.facilities().get({
        parameters: {
          is_enabled: true,
        },
      }),
    });

    eventBus.registerOnce(PAGINATE_CREDENTIALS_USERS, async ({ detail }) => {
      if (!this.fetching) {
        this.userListPosition = detail.listPosition;
        this.fetching = true;
        this.offset = this._data.users.results.length;

        const userGroupUsersData = await accessControlService
          .userGroups({ groupId: this.selectedUserGroup })
          .users()
          .get({ parameters: { specialtyId: this.selectedSpecialty, limit: ITEMS_PER_PAGE, offset: this.offset } });

        eventBus.fire(FETCH_LDAP_GROUP_USERS, {
          data: {
            ...userGroupUsersData,
            results: [...this._data.users.results, ...userGroupUsersData.results],
          },
        });

        this.fetching = false;
      }
    });
  }

  get selectedFacility() {
    return this.getAttribute('selectedFacility');
  }

  set selectedFacility(newSelectedFacility) {
    this.setAttribute('selectedFacility', newSelectedFacility);
  }

  get selectedSpecialty() {
    return this.getAttribute('selectedSpecialty');
  }

  set selectedSpecialty(newSelectedSpecialty) {
    this.setAttribute('selectedSpecialty', newSelectedSpecialty !== null ? newSelectedSpecialty : '');
  }

  get selectedUserGroup() {
    return this.getAttribute('selectedUserGroup');
  }

  set selectedUserGroup(newSelectedUserGroup) {
    this.userListPosition = 0;
    this.selectedUser = '';
    this.setAttribute('selectedUserGroup', newSelectedUserGroup !== null ? newSelectedUserGroup : '');
  }

  get selectedUser() {
    return this.getAttribute('selectedUser');
  }

  set selectedUser(newSelectedUser) {
    this.examListPosition = 0;
    this.setAttribute('selectedUser', newSelectedUser);
  }

  set examListPosition(newExamListPosition) {
    this.setAttribute('examListPosition', newExamListPosition);
  }

  get examListPosition() {
    return this.getAttribute('examListPosition');
  }

  set userListPosition(newUserListPosition) {
    this.setAttribute('userListPosition', newUserListPosition);
  }

  get userListPosition() {
    return this.getAttribute('userListPosition');
  }

  set showEnabled(newShowEnabled) {
    this.setAttribute('showEnabled', newShowEnabled);
  }

  get showEnabled() {
    return this.getAttribute('showEnabled');
  }

  get userFilter() {
    return this.getAttribute('userFilter');
  }

  set userFilter(newUserFilter) {
    this.setAttribute('userFilter', newUserFilter);
  }

  handleScroll() {
    const examList = this.shadowRoot.querySelector('#exam-list');

    if (examList) {
      examList.addEventListener('scroll', event => {
        this.examListPosition = setScrollPosition(event);
      });

      examList.scrollTo({ top: this.examListPosition });
    }

    const userList = this.shadowRoot.querySelector('#user-list');

    if (userList) {
      userList.addEventListener('scroll', event => {
        this.userListPosition = setScrollPosition(event);
      });

      userList.scrollTo({ top: this.userListPosition });
    }
  }

  styles() {
    return `
      .title {
        margin-bottom: 3%;
        font-family: HelveticaNowDisplay;
        font-style: normal;
        font-weight: bold;
        font-size: 34px;
        line-height: 50px;
        letter-spacing: 0.566667px;
        color: #2C2C2E;
      }

      .select-box {
        width: 33%;
        display: inline-block;
      }

      select {
        border: 1px solid #007aff;
        background-color: #ffffff;
        border-radius: 10px;
        width: 100%;
        float: left;
        padding: 15px 20px;
        outline: none;
        -webkit-appearance: none;
        -ms-appearance: none;
        -moz-appearance: none;
        appearance: none;
        margin-left: 5%;
      }

      .select-wrapper {
        width: 90%;
        margin-top: 3%;
        background-color: #FFF;
        display: inline-block;
        position: relative;
      }
      
      .select-wrapper::before {
        content: url(${dropDownSVG});
        position: absolute;
        right: 0%;
        top: 21%;
        pointer-events: none;
      }

      exo-card-title {
        padding-left: 6%;
        ${isSafari() ? 'width: 50%;' : ''}
      }

      .title-wrapper {
        margin-left: 6%;
      }

      .head-section {
        display: flex;
        justify-content: space-between;
        padding-top: 5%;
        align-items: center;
      }

      .show-enabled-container {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
      }

      .show-enabled-label { 
        font-size: 12px;
        font-weight: 400;
        color: rgba(44, 44, 46, 0.503087);
        margin-right: 4px;
      }

      .divider {
        margin: 0 auto;
        width: 90%;
        display: flex;
        justify-content: space-between;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 21px;
        letter-spacing: 0.233333px;
        color: rgba(44, 44, 46, 0.503087);
      }

      .divider-1 {
        margin-right: 2%;
      }

      .items {
        padding: 0;
        width: 100%;
        margin-top: 1%;
        max-height: 350px;
        overflow: auto;
      }

      .enable-all {
        display: flex;
        justify-content: flex-end;
        font-style: normal;
        font-weight: normal;
        width: 90%;
        margin: 0 auto;
        font-size: 10px;
        line-height: 21px;
        letter-spacing: 0.233333px;
        color: rgba(44, 44, 46, 0.503087);
        padding-bottom: 3%;
      }

      .card-container {
        margin-top: 3%;
      }

      .enable-all-label {
        margin-top: 1%;
        margin-right: 2%;
        padding-bottom: 5%;
      }

      .users-count {
        color: rgba(44, 44, 46, 0.5031);
        font-size: 14px;
        padding-right: 6%;
      }   
      
      .flex-title {
        display: flex;
      }      
    
      exo-card-button:last-child {
        margin-left: 10%;
      }

      exo-card-button:last-child {
        margin-left: 10%;
      }

      .card-container {
        display: flex;
      }

      exo-card {
        width: 25%;
      }

      .card-container exo-card:nth-child(2) {
        margin-left: 2%;
      }

      .users {
        cursor: pointer;
      }

      .users-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 10px;
      }

      .users-count {
        margin-left: 8px;
        white-space: nowrap;
        color: rgba(44, 44, 46, 0.5031);
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
      }

      .search-container {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        height: 26px;
        max-width: 160px;
        background: #F2F2F7;
        border-radius: 5px;
      }

      .lens {
        margin-left: 10px;
      }

      input, input:focus {
        width: 70%;
        margin-left: 4px;
        border: none;
        outline: none;
        background: #F2F2F7;
      }
    `;
  }

  getFilteredUsers(items) {
    const lowerCaseFilter = this.userFilter.toLowerCase();
    return items.filter(user => user.username.toLowerCase().includes(lowerCaseFilter)
      || (user.firstName && user.firstName.toLowerCase().includes(lowerCaseFilter)) 
      || (user.lastName && user.lastName.toLowerCase().includes(lowerCaseFilter)));
  }

  renderExoCard({
    title,
    divider,
    items,
    card,
    operation,
    nameKey,
    placeholderTitle,
    selectedItem,
    pagination,
    totalCount,
  }) {
    if (card === 'users' && this.userFilter) {
      items = this.getFilteredUsers(items);
    }

    return `
      <exo-card
        page="credentials"
        class="${this.selectedCard !== card && this.operation !== 'view' ? 'blur' : ''} ${card}"
        ${pagination ? `pagination totalCount=${totalCount} itemscount=${items.length} offset=${items.length}` : ''} >

          <div class="head-section ${card}">
            <exo-card-title ${
              placeholderTitle ? `placeholderTitle="${placeholderTitle}"` : ''
            } title="${title}"></exo-card-title>
            ${
              card === 'credentials'
                ? `
                  <div class="show-enabled-container">
                    <span class="show-enabled-label">Show Enabled</span>
                    <exo-toggle
                      enabled="${this.showEnabled}"
                      class="show-enabled"
                    ></exo-toggle>
                  </div>
                  `
                : ''
            }
          </div>
            ${
              card === 'users'
                ? `
                  <div class="users-container">
                    <div class="search-container">
                      <svg height="13" width="13" class="lens">
                        <image xlink:href="${lensSVG}" height="13" width="13" />
                      </svg>
                      <input type="text" class="user-search" placeholder="Search User" />
                    </div>
                    <div class="users-count">${items.length} Users</div>
                  </div >
                  `
                : ''
            }
          


      
        <div class="divider">
          ${divider.map((d, i) => `<span class="divider-${i}">${d}</span>`).join('')}
        </div>

        <ul class="items paginated" ${
          card === 'users' ? "id='user-list'" : card === 'credentials' ? "id='exam-list'" : ''
        }>
          ${items
            .map(
              item =>
                `<exo-card-list-item
                  page="profile"
                  name="${card === 'credentials' ? item.examType.name : item.name}"
                  operation="${operation}"
                  id="${card === 'credentials' ? item.examType.id : item.id}"
                  card="${card}"
                  ${card === 'users' ? 'viewOnly' : ''}
                  model="${item.model}"
                  enabled="${card === 'credentials' ? item.isCredentialed : item.enabled}"
                  facilityId="${this.selectedFacility}"
                  specialtyId="${this.selectedSpecialty}"
                  userId="${this.selectedUser}"
                  selectedItem="${selectedItem}"
                  ${card === 'users' ? `class="users"` : ''}
                  ${card === 'users' ? `clickable="true"` : ''}
                >
                  ${
                    card === 'credentials'
                      ? item.examType.name
                      : item.lastName && item.firstName
                      ? `${item.lastName}, ${item.firstName}`
                      : item[nameKey]
                  }
                </exo-card-list-item>`,
            )
            .join('')}
        </ul>

        ${
          card !== 'users' && operation === 'view' && items.length > 0
            ? `<div class="enable-all" style="${this.showEnabled === 'true' ? 'display: none;' : 'display:;'}" >
               <span class="enable-all-label">${
                 (card === 'credentials'
                 ? items.every(item => item.isCredentialed)
                 : items.every(item => item.enabled))
                   ? 'Disable All'
                   : 'Enable All'
               }
               </span>
               <exo-toggle
                 card="${card}"
                 facilityId="${this.selectedFacility}"
                 specialtyId="${this.selectedSpecialty}"
                 userId="${this.selectedUser}"
                 all
                 enabled="${
                   card === 'credentials' ? items.every(item => item.isCredentialed) : items.every(item => item.enabled)
                 }"
                ></exo-toggle>
              </div>`
            : ''
        }
      </exo-card>
    `;
  }

  render() {
    let displayedCredentials;
    if (this._data.credentials) {
      const credentials = this._data.credentials;
      displayedCredentials = this.showEnabled === 'true' ? credentials.filter(item => item.isCredentialed) : credentials;
    }

    return `
      <div>
        <div class="title">Credentials</div>
        <div class="top-card-container">
          <horizontal-card>
             <div class="select-box">
                <div class="title-wrapper">
                 <exo-card-title placeholderTitle="Select the" title="Facility"></exo-card-title>
                </div>
               <div class="select-wrapper">
                  <select class="facility-select">
                  <option selected="selected" disabled>Select</option>
                     ${this._data &&
                       this._data.facilities &&
                       this._data.facilities
                         .map(
                           facility =>
                             `<option value="${facility.id}" ${
                               facility.id == this.selectedFacility ? 'selected' : ''
                             }> ${facility.name} </option>`,
                         )
                         .join('')}
                  </select>
                </div>
             </div>
             <div class="select-box">
                <div class="title-wrapper">
                 <exo-card-title placeholderTitle="Select the" title="Specialty"></exo-card-title>
                </div>
               <div class="select-wrapper">
                 <select class="specialty-select" ${
                   this._data && (!this._data.specialities || this._data.specialities.length === 0) ? 'disabled' : ''
                 }>
                 <option selected="selected" disabled>Select</option>
                   ${this._data &&
                     this._data.specialities &&
                     this._data.specialities
                       .map(
                         specialty =>
                           `<option value="${specialty.id}"  ${
                             specialty.id == this.selectedSpecialty ? 'selected' : ''
                           }> ${specialty.name} </option>`,
                       )
                       .join('')}
                 </select>
                </div>
              </div>

              <div class="select-box">
              <div class="title-wrapper">
               <exo-card-title placeholderTitle="Select the" title="User Group"></exo-card-title>
              </div>
             <div class="select-wrapper">
               <select class="ugroup-select" ${
                 this._data && (!this._data.groups || this._data.groups.length === 0) ? 'disabled' : ''
               }>
               <option selected="selected" disabled>Select</option>
                 ${this._data &&
                   this._data.groups &&
                   this._data.groups
                     .map(
                       ugroup =>
                         `<option value="${ugroup.id}"  ${ugroup.id == this.selectedUserGroup ? 'selected' : ''}> ${
                           ugroup.name
                         } </option>`,
                     )
                     .join('')}
               </select>
              </div>
            </div>
          </horizontal-card>
        </div>
        <div class="card-container">
          ${
            this._data && this._data.users && this._data.users.results && this._data.users.results.length
              ? this.renderExoCard({
                  card: 'users',
                  title: 'Users',
                  nameKey: 'username',
                  divider: ['Members'],
                  operation: 'view',
                  pagination: !this.userFilter,
                  totalCount: this._data.users.count,
                  selectedItem: this.selectedUser,
                  items: this._data.users.results.sort((a, b) => {
                    return a.lastName.toUpperCase() > b.lastName.toUpperCase()
                      ? 1
                      : a.lastName.toUpperCase() < b.lastName.toUpperCase()
                      ? -1
                      : a.firstName.toUpperCase() > b.firstName.toUpperCase()
                      ? 1
                      : a.firstName.toUpperCase() < b.firstName.toUpperCase()
                      ? -1
                      : 0;
                  }),
                })
              : ''
          }
          ${
            this._data && this._data.credentials && this._data.credentials.length && this.selectedUser
              ? this.renderExoCard({
                  card: 'credentials',
                  title: 'Credentials',
                  nameKey: 'name',
                  divider: ['Credentials', 'Enable'],
                  operation: 'view',
                  items: displayedCredentials.sort((a, b) =>
                    a.examType.name.toLowerCase() > b.examType.name.toLowerCase() ? 1 : -1,
                  ),
                })
              : ''
          }
        </div>
      </div>
    `;
  }
}

customElements.define('credentials-page', Credentials);
